import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-edit-member-meeting-info",
  templateUrl: "./edit-member-meeting-info.component.html",
  styleUrls: ["./edit-member-meeting-info.component.scss"],
})
export class EditMemberMeetingInfoComponent implements OnInit {
  online_session_link: any = null;
  online_session_app: any = null;
  online_session_notes: any = null;
  apisub: Subscription
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<EditMemberMeetingInfoComponent>
  ) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_EDIT_MEMBER_VIRTUAL_SESSION_INFO){
        if(resdata.result){
          this.activemodal.close({msg:'success'})
        }
      }
    })

  }
  ngOnInit(): void {
    this.online_session_link =
      this.parentdata?.sessionData?.online_session_link;
    this.online_session_app = this.parentdata?.sessionData?.online_session_app;
    this.online_session_notes =
      this.parentdata?.sessionData?.online_session_notes;
  }

  onPost() {
    let obj = {
      member_hash: this.parentdata.memberHash,
      online_session_link: this.online_session_link,
      online_session_notes: this.online_session_notes,
      online_session_app: this.online_session_app,
    };

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });

    this.ls.showLoader = true
    this.apiservice.editMemberVirtualSessionInfo(obj)
  }
}
